import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=136a7c38&scoped=true&"
import script from "./retail.vue?vue&type=script&lang=js&"
export * from "./retail.vue?vue&type=script&lang=js&"
import style0 from "./retail.vue?vue&type=style&index=0&id=136a7c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a7c38",
  null
  
)

export default component.exports